import {
  EditType,
  CodeSettings,
  PagesData,
  LabelItem,
  PageSize,
  UnitType,
  TemplateType
} from "@store/reducers/init/types"
import { inchesToPixel } from "@utils/data"


type InitState = {
  isRow: boolean,
  isComboCustomStyle: boolean
  activeComboChipIndex: any
  dataFields: LabelItem[]
  tags: string[]
  paintSelection: any
  needConfirmation: boolean
  isLoading: boolean
  isImporting: boolean
  isNew: boolean
  badgeName: string
  layout: any
  thirdParty: boolean
  thirdPartyFormat: any
  thirdPartyName: string
  unitType: UnitType
  formats: any
  isCustomFormatSizeMode: boolean
  isCustomPageSizeMode: boolean
  selectedFormat: any
  currentDesignId: string | null
  editType: EditType
  //FormatSettings
  pageSize: PageSize
  pageSizes: { [key: string]: PageSize }
  templateProducts: any
  multiListOption: any
  barCodeSettings: CodeSettings
  imageFilters: any
  activePanel: string
  imageUploads: any[]
  firstLoad: boolean
  enabledModules: string[]
  newDesignOpen: boolean
  newDesignTemplateType: TemplateType
  isModalOpen: boolean
  isBoothSettingModalOpen: boolean
  assignedTktIds: any
  unAssignedTktIds: any
  deletedBoothIds: any
  floormapHoverObjectData: any
  userPermissions: string[]
}
export const initialState: InitState = {
  isRow: false,
  isComboCustomStyle: false,
  activeComboChipIndex: null,
  dataFields: [],
  tags: [],
  paintSelection: null,
  needConfirmation: false,
  isLoading: false,
  isImporting: false,
  isNew: false,
  badgeName: "",
  layout: {
    type: "multi",
    pageMargins: { top: 0, bottom: 0, left: 0, right: 0, centerH: true, centerV: true },
    badgeMargins: { right: 0, bottom: 0 },
    gridSizes: {
      custom: null,
      calculated: { rows: 1, columns: 1 },
    },
    paperSize: { width: 1, height: 1 },
  },

  thirdParty: false, // example: avery, dymo , brother
  thirdPartyFormat: {},
  thirdPartyName: "",

  unitType: "inch", //pixels, inch
  formats: {},
  isCustomFormatSizeMode: false,
  isCustomPageSizeMode: false,
  selectedFormat: {
    id: "2",
    height: 288,
    width: 384,
    name: '4.0" x 3.0"',
    heightInInch: "3",
    widthInInch: "4",
  },
  currentDesignId: null,
  editType: "edit" as EditType,
  //FormatSettings
  pageSize: { name: '4.0" x 3.0"', height: inchesToPixel(3), width: inchesToPixel(4) },
  pageSizes: {},
  templateProducts: {},
  multiListOption: {},
  barCodeSettings: {
    type: "QR_CODE", //QR_CODE, BAR_CODE,Custom-QR-Code,Custom_Bar_CODE
    barcodeType: "code39",
    barLineWidth: 1,
    content: "", //ticketId | orderId | badgeId | Vcard | Custom
    barCode: 0, //TODO: what is this for? Remove if not needed
  },
  imageFilters: {},
  activePanel: "templates",
  imageUploads: [],
  firstLoad: false, //will only set to true when the website will load
  enabledModules: [], //'scan', 'quick', 'attendee',
  newDesignOpen: false,
  newDesignTemplateType: "badge",
  isModalOpen: false,
  isBoothSettingModalOpen: false,
  assignedTktIds: [],
  unAssignedTktIds: {},
  deletedBoothIds: [],
  floormapHoverObjectData: {show: false, data:null},
  userPermissions: [],
}
